import React from 'react';

const baseClasses =
  'inline-flex items-center justify-center font-display font-medium text-sm leading-[1.6] tracking-[-0.14px] whitespace-nowrap transition-transform duration-fast hover:scale-[1.02] active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink-900';

const variantClasses = {
  /* Dark pill, used in the Header. Smaller rounded radius (32px) per Figma. */
  dark:
    'bg-ink-900 text-on-dark rounded-pill-sm px-8 py-3 hover:bg-black focus-visible:outline-on-dark',
  /* Light pill, used in Hero + FinalCTA. Full pill radius (99px). */
  light:
    'bg-on-dark text-ink-900 rounded-pill px-14 py-3 hover:bg-on-dark-soft',
  /* Ghost - footer + secondary nav. */
  ghost:
    'text-ink-700 hover:text-ink-900 px-3 py-2',
};

export function Button({ variant = 'light', as: Tag = 'button', className = '', children, ...rest }) {
  return (
    <Tag className={`${baseClasses} ${variantClasses[variant] || variantClasses.light} ${className}`} {...rest}>
      {children}
    </Tag>
  );
}
